import type { LeadFormProps, LeadFormStepFields } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { BasicLeadForm } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { faBuilding as fasBuilding, faComment as fasComment } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormInput, FormTextArea } from "bm-ui-kit";
import type { ReactNode } from "react";
import React from "react";

type StepFields = LeadFormStepFields;

interface Props extends LeadFormProps {
	questionPlaceholder?: string;
}

export class LeadForm extends BasicLeadForm<StepFields, Props> {
	public static defaultProps = {
		...BasicLeadForm.defaultProps,
		questionPlaceholder: "Kérdés",
	};

	protected renderFields(): ReactNode {
		const { submitState, questionPlaceholder } = this.props;

		return (
			<>
				{super.renderFields()}
				<FormInput
					placeholder="Cégnév"
					name="companyName"
					prepend={<FontAwesomeIcon icon={fasBuilding} />}
					autoComplete="organization"
					validate={this.validCompanyName}
					disabled={submitState !== undefined}
					required
				/>
				<FormTextArea
					placeholder={questionPlaceholder}
					name="question"
					prepend={<FontAwesomeIcon icon={fasComment} />}
					disabled={submitState !== undefined}
				/>
			</>
		);
	}

	private validCompanyName(_companyName: string): string {
		if (!_companyName) {
			return "A cégnév megadása kötelező!";
		}

		const companyName = _companyName?.trim();

		if (companyName.length < 2) {
			return "A cégnév legalább 2 karakterből kell, hogy álljon!";
		}

		if (companyName.length > 40) {
			return "A cégnév legfeljebb 40 karakterből állhat!";
		}
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.LeadForm`;
	}
}
